import {Component, NgZone, ContentChild, ChangeDetectorRef} from "@angular/core";
import {ModalConfig} from "../services/notification/modal.config";
import {EventBus} from "../event/EventBus";
import "rxjs/add/operator/map";
import "rxjs/add/operator/subscribeOn";
import {ComponentBase} from "../base/ComponentBase";
import {BugsnagLoggingService} from "../services/logging/bugsnag-logging.service";
import {PipelineService} from "../services/pipeline/pipeline.service";
import {ISelection, IQuestion, IAnswer, IHint, IQuestionEntry, QuestionType} from  "../api/data-model";
import {PipelineSaveEvent, PIPELINE_API_STATUS} from "./PipelineSaveEvent";
import {RaVersion} from "../services/configuration/ra.version";
import {QuestionReportEvent} from "./QuestionReportEvent";
import {HttpClient} from "@angular/common/http";
import {UtilitiesService} from "../services/utilities.service";
import {AudioState} from "../constants";

@Component({
    selector: "question-editor",
    templateUrl: "./question.editor.component.html",
    styleUrls: ["./pipeline.component.scss"]
})
export class QuestionEditorComponent extends ComponentBase {

    public activateModal: boolean = false;
    public status:string = "";
    public addInProgress:boolean = false;
    public showAdd:boolean = false;
    public newQuestion:IQuestionEntry = new NewQuestion();
    public newQuestionText:string = "new";
    public questionStates:boolean[] = [];

    constructor(private http:HttpClient,
        private eventBus: EventBus,
        private modalConfig: ModalConfig,
        private logService: BugsnagLoggingService,
        private _ngZone: NgZone,
        private pipelineService:PipelineService,
        private ref: ChangeDetectorRef
    ) {
        super("QuestionEditorComponent");
        this.resetQuestion();
        this.questionStates = new Array(this.pipelineService.currentSourceSelection.questionEntries ?
            this.pipelineService.currentSourceSelection.questionEntries.length : 0).fill(false);
    }

    get selection(): ISelection {
        return this.pipelineService.currentSourceSelection;
    }

    public addNewQuestion():void {
        this.resetQuestion();
        this.showAdd = false;
    }

    public cancelNewQuestion(question:IQuestionEntry):void {
        this.resetQuestion();
        this.showAdd = false;
    }

    public addQuestion(question: IQuestionEntry):void {
        this.showAdd = false;
        console.log("current number of entries:" + this.selection.questionEntries.length);
        const newIndex = this.selection.questionEntries.length;
        this.selection.questionEntries.push(question);
        // TODO:  Why do I need to do this?? Uhg. It will not update the UI, otherwise.
        this.saveQuestion(question, newIndex);
        this.ref.detectChanges();
    }

    private resetQuestion():void {
        this.newQuestion = new NewQuestion();
        this.newQuestion.id = this.getNewQuestionID();
        this.newQuestion.question = {
            text: "Add a new one.",
            audio: "",
            audioState: AudioState.UNRECORDED};

        this.newQuestion.answers = [];
    }

    private getNewQuestionID(): string {
        if (!!this.selection) {
            return UtilitiesService.newQuestionID(this.selection.metaData.referenceStory, this.selection.questionEntries.length);

        }
        return "";
    }

    public deleteQuestion(question:IQuestionEntry):void {
        if (confirm("Are you sure you want to delete this?") === true && !!this.selection) {
            try {
                // this.eventBus.next(new PipelineSaveEvent(PIPELINE_SAVE_STATUS.start));
                for (let i in this.selection.questionEntries) {
                    // Carelessly Assuming names are canonical...
                    if (this.selection.questionEntries[i].question.text === question.question.text) {

                        // TODO:Why this cast to Number?
                        this.selection.questionEntries.splice(Number(i), 1);

                        // TODO:  Why do I need to do this?? It will not update the UI, otherwise.
                        this.saveSelection();
                        this.ref.detectChanges();
                    }
                }
            } catch (Exception) {
                console.log("Error: " + Exception);
            }
        }
    }

    public changeType(type: QuestionType):void {
        this.newQuestion.type = type;
    }

    public saveQuestion(question: IQuestionEntry, index: number): void {
        this.pipelineService.replaceHyphensWithEmDashInText(question);
        this.selection.questionEntries[index] = question;
        console.log("in save");
        this.saveSelection();
    }

    public saveSelection():void {
        // TODO: should refactor this to pipelineService
        this.addInProgress = true;
        this.eventBus.next(new PipelineSaveEvent(PIPELINE_API_STATUS.start));
        this.pipelineService.saveSourceContent().subscribe(result => {
            this.logService.log("saved uninflated");
            this.addInProgress = false;
            this.addNewQuestion();
            this.eventBus.next(new PipelineSaveEvent(PIPELINE_API_STATUS.finish,
                this.pipelineService.currentSourceSelection));
            this.ref.detectChanges();
        });
    }

    public makeActive():void {
            this.questionStates =
                new Array(this.questionStates.length).fill(false);
            this.ref.detectChanges();
    }

    public makeInactive(): void {
        this.questionStates =
            new Array(this.questionStates.length).fill(false);
        this.ref.detectChanges();
        this.showAdd = false;

    }

    public setQuestionActive(idx: string):void {
        let index:number;
        this.questionStates = new Array(this.questionStates.length).fill(false);
        this.showAdd = false;
        if (idx === this.newQuestionText) {
            this.logService.log("setting question active for new");
            this.newQuestion.question.text = "";
            this.showAdd = true;
        } else {
            index = parseInt(idx, 10);
            if (index >= 0) {
                this.questionStates[index] = true;
            }
        }
        this.ref.detectChanges();
    }

    public getQuestionActive(idx: string):boolean {
        let active:boolean;
        // this.logService.log("getting active state for idx: " + idx);
        if (idx === this.newQuestionText) {
            active = this.showAdd;
        } else {
            active = this.questionStates[parseInt(idx, 10)];
        }
        // this.logService.log("getting active state for idx: " + idx + ": " + active);
        return active;
    }

    public showQuestionReport():void {
        this.eventBus.next(new QuestionReportEvent());
    }

}

export class NewQuestion implements IQuestionEntry {
    type: QuestionType;
    presentation: string;
    id: string;
    context: string;
    thinking: string;
    skill: string;
    question: IQuestion;
    answers: IAnswer[];
}
